// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kvKJ","buttons":"styles_buttons__sm4yi"};